/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import plcLogo from '@/assets/carMicroprocessor.png'

function CarComputerNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} />
      <Handle type="target" id="right" position={Position.Right} />

      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={plcLogo} alt="Compute Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Onboard Computer</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default CarComputerNode
